// src/components/FTSearchModal.jsx
import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import FullTextSearchBox from '../components/FullTextSearchBox/FullTextSearchBox';
import SyntaxExplainer from '../../components/FullTextSearch/FullTextSyntaxCard/SyntaxExplainer';

const useStyles = makeStyles(() => ({
  modalClassConDSI: { borderRadius: "8px" },
  topBar: {
    padding: '12px 20px 0px 17px',
    borderBottom: 'none',
  },
  bodyPad: { padding: '15px' },
  footerBar: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '8px',
    padding: '10px 16px'
  },
  btn: {
    padding: '8px 14px',
    borderRadius: '4px',
    cursor: 'pointer',
    border: 'none',
    '&:disabled': {
      opacity: 0.5,
      cursor: 'not-allowed',
      color: 'rgb(0 0 0 / 26%)'
    }
  },
  btnGrey: { background: '#e0e0e0', color: '#222' },
  btnBlue: { background: '#1976d2', color: '#fff' },
  btnOrange: { background: '#db862c', color: '#fff' }
}));

const defaultFTState = {
  field: 'SUBJECT_FTS',
  value: '',
  fieldDisplayValue: '',
  tempFieldDisplayValue: ''
};

const FTSearchModal = ({ show, closeModal, callback, initial,discoverFTSValue}) => {
  console.log(initial,'initial');
  console.log('discoverFTSValue',discoverFTSValue);  
  const classes = useStyles();
  const toggle = useSelector(state => state?.setToggle?.toggle);

  const [ftsState, setFtsState] = useState(() => {
    // Seed from discoverFTSValue if provided
    if (discoverFTSValue && typeof discoverFTSValue === 'string') {
      return {
        ...defaultFTState,
        fieldDisplayValue: discoverFTSValue,
        tempFieldDisplayValue: discoverFTSValue,
        value: '' // or keep parsed lucene here if you want
      };
    }
    if (initial) return initial;
    return defaultFTState;
  });

  // Add a key to force re-render of FullTextSearchBox
  const [componentKey, setComponentKey] = useState(0);
  
  // Add state for Tooltips
  const [syntaxShow, setSyntaxShow] = useState(false);

  useEffect(() => {
    if (show) {
      if (discoverFTSValue && typeof discoverFTSValue === 'string') {
        setFtsState(prev => ({
          ...prev,
          fieldDisplayValue: discoverFTSValue,
          tempFieldDisplayValue: discoverFTSValue,
          // keep prev.value (parsed) or reset if you prefer
        }));
      } else if (initial) {
        setFtsState(initial);
      }
    }
  }, [show, discoverFTSValue, initial]);

  const setFTString = (endString) => {
    setFtsState(prev => ({
      ...prev,
      fieldDisplayValue: endString,
      tempFieldDisplayValue: endString
    }));
  };
  
  const handleCopy = () => {
    const textToCopy = ftsState.fieldDisplayValue || ftsState.tempFieldDisplayValue || '';
    if (textToCopy) {
      navigator.clipboard.writeText(textToCopy)
        .then(() => {
          // Optional: Show a success message
          console.log('Text copied to clipboard');
        })
        .catch(err => {
          console.error('Failed to copy text: ', err);
        });
    }
  };

  const handleClear = () => {
    const clearedState = {
      field: 'SUBJECT_FTS',
      value: '',
      fieldDisplayValue: '',
      tempFieldDisplayValue: ''
    };
    setFtsState(clearedState);
    // Force re-render of FullTextSearchBox component in modal
    setComponentKey(prev => prev + 1);
    // Don't call callback here - only when Save is clicked
  };

  const handleSave = () => {
    callback?.(ftsState);
    closeModal?.();
  };

  const handleClose = () => {
    // When closing without saving, just close the modal
    closeModal?.();
  };

  // Check if there's any text in the input
  const hasInputText = !!(ftsState.fieldDisplayValue || ftsState.tempFieldDisplayValue);

  return (
    <Modal
      size="lg"
      centered
      show={show}
      onHide={handleClose}
      contentClassName={classes.modalClassConDSI}
    >
      {/* <div
        className={classes.topBar}
        style={toggle ? { backgroundColor: '' } : { backgroundColor: '#292929' }}
      > */}
        {/* <Link href="#" onClick={(e) => e.preventDefault()}>
          <CloseIcon onClick={closeModal} />
        </Link>
      </div> */}
      {/* <h5>Full text Search</h5> */}

      <Modal.Header
        className={classes.topBar}
        closeButton
        style={toggle ? { backgroundColor: '' } : { backgroundColor: '#292929', borderBottomColor: '#444' }}>
        <Modal.Title>
          <span>Full Text Search</span>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body
        className={classes.bodyPad}
        style={toggle ? { backgroundColor: '' } : { backgroundColor: '#292929' }}
      >
        <FullTextSearchBox
          key={componentKey}
          setSearchLock={() => { }}
          starterString={ftsState.tempFieldDisplayValue || ftsState.fieldDisplayValue}
          setLuceneQueryValue={(luceneObj) =>
            setFtsState(prev => ({ ...prev, value: luceneObj }))
          }
          endString={setFTString}
          setNodeId={() => ""}
        />
      </Modal.Body>

      <div className={classes.footerBar}>
        <span style={{ display: 'flex', alignItems: 'center' }}>
          <span onClick={() => setSyntaxShow(!syntaxShow)} className={"appLink"} style={{ cursor: 'pointer' }}>
            Tooltips
          </span>
        </span>
        <button className={`${classes.btn} ${classes.btnGrey}`} onClick={handleClose}>
          Cancel
        </button>
        <button className={`${classes.btn} ${classes.btnBlue}`} onClick={handleSave}>
          Save
        </button>
      </div>
      
      {syntaxShow && (
        <div style={{ padding: '15px', marginLeft: '-69px' }}>
          <SyntaxExplainer />
        </div>
      )}
    </Modal>
  );
};

export default FTSearchModal;

